module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/speaker-8439dc21240c38db4a937aaed56c74ff.svg";